var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3558 13.5L9.98605 12.25V7.02319M18.9721 11C18.9721 5.47715 14.9489 1 9.98605 1C5.02319 1 1 5.47715 1 11C1 16.5228 5.02319 21 9.98605 21C13.3122 21 16.2162 18.989 17.7699 16M16.507 9.9026L18.7535 12.4026L21 9.9026",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLog);
export default __webpack_public_path__ + "static/media/active_log.2de0c5a30a7b87b184c8efbb134f5030.svg";
export { ForwardRef as ReactComponent };